import {ApiResponse, ApiError} from './types';
import * as runtime from './runtime';
import {omit, isEmpty} from 'lodash';
import {isStatusCodeError} from '../../main/lib/net/isStatusCodeError';

export async function convertFetchResponseToApiResponse<Result>(
    openapiApiResponse?: runtime.ApiResponse<Result>
): Promise<ApiResponse<Result>> {
    if (!openapiApiResponse) {
        return {
            errors: [
                {
                    message: 'Please check your internet connection and try again.',
                },
            ],
        };
    }

    let data: any;
    let text: string | undefined = undefined;
    const response = openapiApiResponse.raw;

    const contentType = response?.headers?.get('content-type')?.split(';')?.[0];
    if (contentType === 'application/json') {
        data = await response.json();
    } else if (contentType === 'application/pdf' || contentType === 'application/octet-stream') {
        data = await response.blob();
    } else {
        text = await response.text();
    }

    const errors = parseErrorsFromResponseData(data);

    return {
        data,
        text,
        errors,
        statusCode: response.status,
    };
}

export async function convertFetchResponseToReactQueryResponse<Result>(response: ApiResponse<Result>): Promise<Result> {
    if (response.errors) {
        throw response.errors;
    }
    if (isStatusCodeError(response.statusCode)) {
        throw [];
    }
    return (response.data || response.text) as Result;
}

export function parseErrorsFromResponseData(data: any): Array<ApiError> | undefined {
    if (data === undefined) {
        return undefined;
    }
    if (Array.isArray(data?.errors)) {
        return data.errors;
    }
    if (
        data &&
        ('code' in data || 'message' in data || 'property' in data || 'details' in data) &&
        isEmpty(omit(data, 'code', 'message', 'property', 'details', 'args'))
    ) {
        return [{message: data.message, code: data.code}];
    }
}
